<template>
  <div>
    <Homeicon />
    <UserName />
    <Backicon v-if="$route.name !== 'Home'"/>
    <img @click="showModal" class="tutorial_button" src="@/assets/img/how_to_play.png" />
    <Modal @test="is_active = $event" :is_active="is_active"></Modal>
  </div>
</template>

<script>
import Homeicon from "@/components/Homeicon";
import UserName from "@/components/UserName";
import Backicon from "@/components/Backicon";
import Modal from "@/components/Modal";
export default {
  name: "Header",
  data() {
    return {
      is_active: false,
    }
  },
  methods: {
    showModal() {
      this.is_active = true;
    }
  },
  components: {
    Homeicon,
    UserName,
    Backicon,
    Modal
  },
};
</script>
<style scoped>
  .tutorial_button {
    width: 200px;
    position: absolute;
    top: -30px;
    left: 130px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue